import clsx, { ClassValue } from 'clsx';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IMenuTypes } from 'utils/models';

import MenuAction from 'components/MenuAction';

import { SvgDownArrow, SvgHazelBrand, SvgSideSettings } from 'components/SvgIcons';
import { CONF_ENVIRONMENT } from 'utils/config';
import { IS_DEV } from 'utils/constants';

interface IHeader {
  className?: ClassValue;
  menu: IMenuTypes[];
  adminName?: string;
}

const Header: FC<IHeader> = ({ className, menu, adminName = 'Admin' }) => {
  const isDev = IS_DEV.includes(CONF_ENVIRONMENT || 'development');

  return (
    <div className={clsx(className, 'relative w-full')}>
      {/* Desktop */}
      <div className="hidden md:block p-3 mx-auto">
        <div className="flex justify-between items-center">
          {/* Left */}
          <div className="flex items-center p-2">
            <Link to="/">
              <div className="flex  space-y-0.5 text-left">
                {' '}
                <SvgHazelBrand className="text-hazel-solid-green-600 w-16 h-5" />
                <div className="text-hazel-light-gray-300 text-xs uppercase font-NectorMono-Regular px-5 font-light">
                  <span className="pr-4">|</span> Admin Dashboard
                </div>
              </div>
            </Link>

            {isDev && (
              <span className="ml-4 rounded-full bg-red-100 text-red-700 text-xxs px-8 py-1 uppercase">
                {CONF_ENVIRONMENT} Environment
              </span>
            )}
          </div>

          {/* Right */}
          <div className="flex justify-end items-center -mr-4">
            <div className="hidden md:inline-block">
              <div className="flex items-center space-x-3 mr-5">
                <div className="!ml-5">
                  <div className="text-sm text-hazel-light-gray-300 font-Sohne-Semibold text-right">
                    {adminName}
                  </div>
                  <div className="text-hazel-light-gray-300 text-xs uppercase font-NectorMono-Regular">
                    Hazel Admin
                  </div>
                </div>

                <MenuAction
                  menuButton={
                    <div className="flex items-center space-x-2 cursor-pointer">
                      <div className="rounded-md h-9 w-9 border flex items-center justify-center bg-white">
                        <SvgSideSettings className="w-5 h-5 text-hazel-light-gray-300" />
                      </div>
                      <SvgDownArrow className="w-3 h-3 text-hazel-light-gray-300" />
                    </div>
                  }
                  classNameMain="ml-0"
                  menu={menu}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
